import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Layout from '@/layout';
export default {
  path: '/yiyuanAdmin',
  component: Layout,
  redirect: '/yiyuanAdmin',
  name: 'yiyuanAdmin',
  meta: {
    title: '医院管理',
    icon: 'jichu'
  },
  hidden: false,
  children: [{
    path: '',
    component: function component() {
      return import('@/views/yiyuanAdmin');
    },
    name: 'yiyuanAdmin',
    meta: {
      title: '医院管理'
    },
    hidden: false
  }]
};